import { omit } from 'ramda';
import React from 'react';
import Checkbox from '../../../commons/component/checkbox';
import Error from '../../../commons/component/error';
import Input from '../../../commons/component/input';
import { InputPhone } from '../../../commons/component/input-mask';
import InputNumber from '../../../commons/component/input-number';
import Select from '../../../commons/component/select';
import styled from 'styled-components';
import {
  checkNameField,
  checkPhoneExtensionRegistryField,
  checkPhoneField,
  hasError,
  removeErrorMessage,
  setBlankErrorMessage
} from '../../cadastro-services';
import { NextStepAnimation } from '../../keyframes';

const ThirdStepComponent = ({
  updateState,
  cadastroState,
  stateRegistryRef,
  phoneRef,
  contactNameRef
}) => {
  const { errors } = cadastroState;
  return (
    <ThirdStepWrapper>
      <div className="taxes__wrapper">
        <div className="inputGroup" id="taxInfo">
          <label className="inputGroup-label">
            <span className="required-asterisk">*</span> informações tributárias
          </label>
          <Select
            name="taxInfo"
            value={cadastroState.company.taxInfo}
            onChange={e => {
              const filteredErrors =
                e.target.value === 'EXEMPT_TAXPAYER'
                  ? omit(['stateRegistry'], cadastroState.errors)
                  : { ...cadastroState.errors };
              updateState({
                ...cadastroState,
                company: { ...cadastroState.company, taxInfo: e.target.value },
                errors: { ...filteredErrors }
              });
            }}
            checked={cadastroState.company.taxInfo}
            className={`inputGroup-input ${hasError('taxInfo', errors)}`}
            options={{
              TAXPAYER_ICMS: 'contribuinte ICMS',
              NOT_TAXPAYER: 'não contribuinte ICMS',
              EXEMPT_TAXPAYER: 'isento de inscrição estadual'
            }}
          />
          <Error errors={errors} name="taxInfo" />
        </div>
        <div className="inputGroup checkbox">
          <Checkbox
            className="inputGroup-checkbox"
            name="nationalSimple"
            onChange={() =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  nationalSimple: !cadastroState.company.nationalSimple
                }
              })
            }
            checked={cadastroState.company.nationalSimple}
            data-form="signup"
            data-page="signup"
            disabled={!(cadastroState.company.taxInfo === 'TAXPAYER_ICMS')}
          >
            simples nacional
          </Checkbox>
        </div>
      </div>

      <div className="inputGroup" id="stateRegistry">
        <label className="inputGroup-label" htmlFor="stateRegistry-input">
          {cadastroState.company.taxInfo !== 'EXEMPT_TAXPAYER' && (
            <span className="required-asterisk">*</span>
          )}{' '}
          inscrição estadual
        </label>
        <InputNumber
          name="stateRegistry"
          id="stateRegistry-input"
          onChange={e =>
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                stateRegistry: e.target.value
              }
            })
          }
          onBlur={e => {
            if (!Boolean(e.target.value)) {
              setBlankErrorMessage('stateRegistry', cadastroState, updateState);
            } else {
              removeErrorMessage('stateRegistry', cadastroState, updateState);
            }
          }}
          value={cadastroState.company.stateRegistry}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input ${hasError('stateRegistry', errors)}`}
          type="text"
          mask="____________________"
          disabled={cadastroState.company.taxInfo === 'EXEMPT_TAXPAYER'}
          inputRef={cadastroState.company.taxInfo !== 'EXEMPT_TAXPAYER' ? stateRegistryRef : null}
          required={cadastroState.company.taxInfo !== 'EXEMPT_TAXPAYER'}
        />
        <Error errors={errors} name="stateRegistry" />
      </div>

      <div className="phone__wrapper">
        <div className="inputGroup" id="phone">
          <label className="inputGroup-label" htmlFor="phone-input">
            <span className="required-asterisk">*</span> telefone empresarial
          </label>
          <InputPhone
            data-form="signup"
            data-page="signup"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  phone: e.target.value
                }
              })
            }
            onBlur={e => checkPhoneField(e.target.value, cadastroState, updateState)}
            value={cadastroState.company.phone}
            name="phone"
            id="phone-input"
            className={`inputGroup-input ${hasError('phone', errors)}`}
            type="text"
            placeholder="Ex: (99) 99999-9999"
            inputRef={phoneRef}
            required
          />
          <Error errors={errors} name="phone" />
        </div>
        <div className="inputGroup">
          <label className="inputGroup-label" htmlFor="phoneExtensionRegistry-input">
            ramal
          </label>
          <InputNumber
            name="phoneExtensionRegistry"
            id="phoneExtensionRegistry-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  phoneExtensionRegistry: e.target.value
                }
              })
            }
            onBlur={e =>
              checkPhoneExtensionRegistryField(
                e.target.value,
                'phoneExtensionRegistry',
                cadastroState,
                updateState
              )
            }
            value={cadastroState.company.phoneExtensionRegistry}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input phoneExtensionRegistry ${hasError(
              'phoneExtensionRegistry',
              errors
            )}`}
            type="text"
            mask="_____"
          />
        </div>
      </div>

      <div className="inputGroup" id="contactName">
        <label className="inputGroup-label" htmlFor="contactName-input">
          <span className="required-asterisk">*</span> nome do contato de cobrança
        </label>
        <Input
          name="contactName"
          id="contactName-input"
          onChange={e =>
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                contactName: e.target.value
              }
            })
          }
          onBlur={e => checkNameField(e.target.value, 'contactName', cadastroState, updateState)}
          value={cadastroState.company.contactName}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input --large ${hasError('contactName', errors)}`}
          type="text"
          inputRef={contactNameRef}
          required
        />
        <Error errors={errors} name="contactName" />
      </div>

      <div className="inputGroup --checkbox">
        <Checkbox
          className="inputGroup-checkbox"
          name="authorizeInfoShare"
          onChange={() =>
            updateState({
              ...cadastroState,
              authorizeInfoShare: !cadastroState.authorizeInfoShare
            })
          }
          checked={cadastroState.authorizeInfoShare}
          data-form="signup"
          data-page="signup"
        >
          Eu autorizo a americanas S.A e empresas parceiras a realizarem análise de crédito para
          oferecer as melhores formas de pagamento.
        </Checkbox>
      </div>
    </ThirdStepWrapper>
  );
};

const ThirdStepWrapper = styled.div`
  animation: ${NextStepAnimation} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`;

export default ThirdStepComponent;
